import React from 'react'
import {Flex, Spinner} from '/app/src/component';

function LoadingScreen() {
    return (
        <Flex width='100%' height='100%'>
            <Spinner/>
        </Flex>
    )
}

export default LoadingScreen;



// WEBPACK FOOTER //
// ./src/component/LoadingScreen/index.js